/**
 * reducers/webhooks.ts
 * desc: client webhooks
 * note: connects to third-party systems via Y Meadows API endpoints
 */

import type { Reducer } from '@reduxjs/toolkit';
import type { WebhooksAction } from '../actions/webhooks';
import type { ApiErrorJson } from '../../utilities/error';
import type { CustomerMessage } from '../../types/api/customer-messages';

export interface WebhooksState {
    isLoading: {
        createWebhookSource: boolean;
    };
    // an empty object until the first call; then the created message, or the API error
    detail: CustomerMessage | ApiErrorJson | Record<string, never>;
}

const INITIAL_STATE: WebhooksState = {
    isLoading: {
        createWebhookSource: false,
    },
    detail: {}
};

function webhooksReducer(state: WebhooksState = INITIAL_STATE, action: WebhooksAction): WebhooksState {
    switch (action.type) {

        // CREATE Webhook Source (Instance)
        case 'CREATE_WEBHOOKS_SOURCE_ERROR':
            return _createWebhooksSourceError(state, action.payload);
        case 'CREATE_WEBHOOKS_SOURCE_REQUEST':
            return _createWebhooksSourceRequest(state);
        case 'CREATE_WEBHOOKS_SOURCE_SUCCESS':
            return _createWebhooksSourceSuccess(state, action.payload);

        default:
            return state;
    }
}



//*************************************************
//*****   CREATE Webhook Source (Instance)   ******
//*************************************************
function _createWebhooksSourceError(state: WebhooksState, payload: ApiErrorJson): WebhooksState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            createWebhookSource: false,
        },
        detail: payload,
    };
}

function _createWebhooksSourceRequest(state: WebhooksState): WebhooksState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            createWebhookSource: true,
        },
    };
}

function _createWebhooksSourceSuccess(state: WebhooksState, payload: CustomerMessage): WebhooksState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            createWebhookSource: false,
        },
        detail: payload
    };
}

export default webhooksReducer as Reducer<WebhooksState>;
